const getters = {
  getProducts: (state, getters, rootState) => {
    return _.map(state.products, (product) => {
      product.name = product.name ? product.name : 'Unknown product';
      // _.map(product.locations, (location) => {
      //   return location.name
      // })
      return product
    })
  }

}

export default getters
